export const INVOICE_STATUS = {
    draft:     { label: 'Draft',     tone: 'bg-slate-100 text-slate-700 border-slate-200' },
    sent:      { label: 'Sent',      tone: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
    part_paid: { label: 'Part Paid', tone: 'bg-amber-50 text-amber-800 border-amber-200' },
    paid:      { label: 'Paid',      tone: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
    overdue:   { label: 'Overdue',   tone: 'bg-red-50 text-red-700 border-red-200' },
    cancelled: { label: 'Cancelled', tone: 'bg-slate-100 text-slate-500 border-slate-200' },
};
export const INVOICE_STATUS_ORDER = ['draft', 'sent', 'part_paid', 'paid', 'overdue', 'cancelled'];

export const INVOICE_TYPE = {
    setup:        { label: 'Setup' },
    saas_monthly: { label: 'SaaS Monthly' },
    saas_annual:  { label: 'SaaS Annual' },
    manual:       { label: 'Manual' },
};
export const INVOICE_TYPE_ORDER = ['setup', 'saas_monthly', 'saas_annual', 'manual'];

export const GBP = (v) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(Number(v || 0));
